import React, { useEffect, useState } from "react";
import ProductList from "../../components/AdvanceDynamicList/ProductList";
import { getStoredData } from "../../json/fecthData";
import { useApiData } from "../../components/ApiDataProvider/ApiDataProvider";
import {hasPermission } from "../../pages/Login/authUtils";


const InventoryPanel = () => {
  const data = getStoredData()?.[1] || {};
  // const TitleInventory = data.TitleInventory || "Inventory";
  const AdminInventory = data.AdminInventory || [];
  const RedirectAdminInventory = data.RedirectAdminInventory;
  const ApiInventory = data.ApiInventory;
  const roleCompare = data.roleCompare || [];
  const StatusInventory = data.InventoryStatus || [];

  const { apiData } = useApiData(["inventory"]);
  const [inventoryItems, setInventoryItems] = useState([]);
  const canDelete = hasPermission("inventory:delete");
  const canUpload = hasPermission("inventory:upload");
  const canDownload = hasPermission("inventory:download");


  // const user = getUser();


  useEffect(() => {
    if (Array.isArray(apiData?.inventory)) {
      setInventoryItems(apiData.inventory);
    }
  }, [apiData?.inventory]);

  return (
    <div className="InventoryPanel">
      <ProductList
        products={inventoryItems}
        setProducts={setInventoryItems}
        fields={AdminInventory}
        redirect={RedirectAdminInventory}
        deleteApi={ApiInventory}
        roleCompare={roleCompare}
        createPath={hasPermission("inventory:create") ? "/inventory/create" : null}
        showDelete={canDelete}
        showUpload={canUpload}
        showDownload={canDownload}
        status = {StatusInventory}
        title={data.TitleInventory}
      />
    </div>
  );
};

export default InventoryPanel;
